import * as clack from '@clack/prompts'
import fs from 'node:fs'
import path from 'node:path'
export function resolveLocalShadcnBin(cwd: string): string {
  const binName = process.platform === 'win32' ? 'shadcn.cmd' : 'shadcn'
  const shadcnBin = path.join(cwd, 'node_modules', '.bin', binName)

  if (!fs.existsSync(shadcnBin)) {
    clack.cancel(
      `shadcn is not installed in this project. Run 'betterstart update-deps' and try again.`
    )
    process.exit(1)
  }

  return shadcnBin
}
